import React, { useEffect, useRef, useState } from 'react';
import cn from 'clsx';

import styles from './style.module.scss';

export interface ListProps {
    onSelect: (id: number) => void;
    data: Array<{ id: number; label: string }>;
    selectedId?: number;
}

const InteractiveList = ({ data, onSelect, selectedId }: ListProps) => {
    const selectedListItemRef = useRef<HTMLLIElement>(null);
    const [selected, setSelected] = useState<number | undefined>(selectedId);
    useEffect(() => {
        // Disabled in 2027.1 tech debt sprint, to allow adding tighter eslint rules
        // eslint-disable-next-line @eslint-react/set-state-in-effect
        setSelected(selectedId);
    }, [selectedId]);

    useEffect(() => {
        if (selectedListItemRef.current)
            selectedListItemRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, [selected]);

    return (
        <ul className={styles.listWrapper}>
            {data.map((x) => {
                return (
                    <li
                        role="treeitem"
                        key={x.id}
                        aria-selected={selected === x.id}
                        className={styles.listItem}
                        ref={selected === x.id ? selectedListItemRef : undefined}
                    >
                        <button
                            className={cn(styles.listButton, { [styles.selectedItem]: selected === x.id })}
                            type="button"
                            onClick={() => {
                                setSelected(x.id);
                                onSelect(x.id);
                            }}
                            onKeyDown={(event) => {
                                if (event.code === 'Enter' || event.code === 'Space') {
                                    setSelected(x.id);
                                    onSelect(x.id);
                                }
                            }}
                        >
                            {x.label}
                        </button>
                    </li>
                );
            })}
        </ul>
    );
};

export default InteractiveList;
